import Token from '@/utils/Token';

export default {
    parse(data) {
        ['ativo'].forEach(item => {
            data[item] = parseInt(data[item]);
        });

        return data;
    },
    
    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/usuario/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/usuario/list${params}`, Token.getHeader());
    },
    option(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/usuario/option${params}`, Token.getHeader());
    },
    totalAtivo(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/usuario/totalAtivo${params}`, Token.getHeader());
    },

    create(params) {
        return axios.post(`/api/usuario`, params, Token.getHeader());
    },
    update(id,params) {
        return axios.post(`/api/usuario/${id}`, params, Token.getHeader());
    },
    senha(id,params) {
        return axios.post(`/api/usuario/senha/${id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/usuario/${id}`, Token.getHeader());
    },
}